import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/validacaoFaseEsteira');

export const verificarPermissaoFase = async (idProposta: string): Promise<boolean> => {
  try {
    const { data } = await axiosInstance.get<boolean>(
      `/permissaoFase/${idProposta}`
    );
    return data;
  } catch (error) {
    console.error('Erro ao verificar permissão:', error);
    return false;
  }
};